const LambdaIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
            <path fill="#F98B9E" fillOpacity=".6" d="M15,8 C15,11.866 11.866,15 8,15 C4.134,15 1,11.866 1,8 C1,4.134 4.134,1 8,1 C11.866,1 15,4.134 15,8"/>
            <polygon fill="#231F20" fillOpacity=".7" points="2.724 0 0 0 0 1 2 1 2.4 2 0 7 1.2 7 3 3.2 4.8 7 6 7" transform="translate(5 4)"/>
        </g>
    </svg>
}

export {LambdaIcon}